import { render } from "./Coin.vue?vue&type=template&id=76637a1f"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Coin.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "76637a1f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('76637a1f', __exports__)) {
    api.reload('76637a1f', __exports__)
  }
  
  module.hot.accept("./Coin.vue?vue&type=template&id=76637a1f", () => {
    api.rerender('76637a1f', render)
  })

}


export default __exports__